import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  InputBase,
  MenuItem,
  Select,
  Stack,
  styled,
  useMediaQuery,
} from '@mui/material';
import img1 from 'assets/img1.png';
import { H5, H6, Small } from 'components/Typography';
import React, { useState } from 'react';
import { ThumbsUp, Trash2 } from 'react-feather';
// import ArrowForwardIosSharp from "@mui/icons-material/ArrowForwardIosSharp";
import { ArrowBackIosNewSharp } from '@mui/icons-material';
import avatar3 from 'assets/avatar-3.png';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import ReversePagination from 'components/ReversePagination';
import { useNavigate } from 'react-router-dom';
import Comment from './Comment';
import CreateCommentBox from './CreateCommentBox';
// ----------------------------------
// styled components

const description = `안녕하세요! 요즌 가장  재밌게 플레이하고 있는 땡땡마법사 완전 제 취향이라 너무 재밌내요ㅎㅎ

재밌게 플레이하다보니 항상 체력이 모자른데요 ㅠㅠ

편지로 보내주는 체력들이 참 쏠쏠합니다!


아무튼 본론으로 들어가서
체력이 충전까지 얼마나 걸리는지 시간 표기가 되면 너무 좋을거 같아요.

1개 충전당 걸리는 시간이나 아니면 완충까지 걸리는 시간 등을 표기해주는 기능이 추가되면 좋을거 같아 건의드립니다.`;

const commentData = [
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: true,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment:
      '긴 댓글 예시입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다',
    delete: false,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: false,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: false,
  },
];

export default function Post({ isModal }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const [commentValue, setCommentValue] = useState('');
  const [selectValue, setSelectValue] = useState('등록순');

  const handleChange = event => {
    setSelectValue(event.target.value);
  };

  const handleCommentChange = event => {
    setCommentValue(event.target.value);
  };

  const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '1rem 2rem 1rem 2rem',
    justifyContent: 'space-between',
    flexDirection: 'column',
    border: isModal ? 'none' : '1px solid #E1E1E1',
    [theme.breakpoints.down('sm')]: {
      // padding: "2rem",
      padding: '1rem 0rem 0rem 0rem',
      textAlign: 'center',
      marginLeft: '-1rem',
      marginRight: '-1rem',
      borderRadius: 0,
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <>
      <StyledCard>
        <Box
          pt={isMobile ? 0 : 2}
          pb={3}
          px={isModal && isMobile ? 4 : isMobile ? 2 : 0}
          sx={{ width: '100%' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box
              onClick={() => navigate('/naver/forumlist')}
              mb={1}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                cursor: 'pointer',
                width: '100%',
              }}
            >
              <ArrowBackIosNewSharp
                sx={{
                  fontSize: 14,
                  color: 'primary.darkBlue',
                  marginRight: 1,
                }}
              />
              <H6 sx={{ color: 'primary.darkBlue', fontWeight: 600 }}>
                게시판 제목
              </H6>
            </Box>

            {!isModal && (
              <Grid
                container
                direction={'row'}
                mb={1.5}
                py={isMobile ? 1 : 0}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Grid item>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Grid item>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '32px',
                          fontSize: 14,
                          color: 'primary.grey2',
                          borderRadius: 2,
                          borderRadius: 2,
                          fontWeight: 500,
                          backgroundColor: '#ffffff',
                          width: '60px',
                          minWidth: '60px',
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        이전글
                      </Button>
                    </Grid>
                    <Grid item ml={1.5}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '32px',
                          fontSize: 14,
                          color: 'primary.grey2',
                          borderRadius: 2,
                          borderRadius: 2,
                          fontWeight: 500,
                          backgroundColor: '#ffffff',
                          width: '60px',
                          minWidth: '60px',
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        다음글
                      </Button>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Box>
          <H5 sx={{ fontSize: '19px', fontWeight: 700, textAlign: 'left' }}>
            차이점 찾기 이벤트
          </H5>
        </Box>

        <Box
          mt={isMobile ? 2 : 0}
          mb={2}
          sx={{
            backgroundColor: '#E1E1E1',
            width: '100%',
            height: '1px',
          }}
        ></Box>

        <Grid
          container
          direction={'row'}
          mb={2}
          px={isModal && isMobile ? 4 : isMobile ? 2 : 0}
          py={isMobile ? 1 : 0}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Grid
            mb={isMobile ? 2 : 0}
            item
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <FlexBox alignItems="center">
              <AppAvatar
                alt={'avatar'}
                src={avatar3}
                style={{ width: '42px', height: '42px' }}
              />
              <FlexBox flexDirection="column" ml={1.2}>
                <H6 sx={{ fontWeight: 600 }}>GM 보조 마법사</H6>
                <Small mb={0.5}>2023.12.28</Small>
              </FlexBox>
            </FlexBox>
          </Grid>

          <Grid item sx={{ display: 'flex', flexDirection: 'row' }}>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '38px',
                  fontSize: 15,
                  color: 'primary.grey2',
                  borderRadius: 2,
                  maxWidth: 110,
                  borderRadius: 2,
                  fontWeight: 500,
                  minWidth: 'fit-content',
                }}
              >
                <ThumbsUp
                  color="#636469"
                  size={18}
                  style={{ marginRight: '4px', marginBottom: '2px' }}
                />
                5
              </Button>
            </Grid>

            <Grid item ml={1.5}>
              <Button
                variant="outlined"
                size="small"
                onClick={() =>
                  navigate('/dashboard/texteditor', { state: { from: 'edit' } })
                }
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '38px',
                  fontSize: 15,
                  color: 'primary.grey2',
                  borderRadius: 2,
                  maxWidth: 110,
                  borderRadius: 2,
                  fontWeight: 500,
                  minWidth: 'fit-content',
                }}
              >
                수정
              </Button>
            </Grid>

            <Grid item ml={1.5}>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  height: '38px',
                  fontSize: 14.5,
                  borderRadius: 2,
                  maxWidth: 110,
                  borderRadius: 2,
                  minWidth: 'fit-content',
                }}
              >
                <Trash2 color="#E95050" size={20} />
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <img
          src={img1}
          alt="check"
          style={{
            // height: isMobile ? "160px" : "240px",
            width: '100%',
            objectFit: 'cover',
            borderRadius: isMobile ? 0 : 10,
          }}
        />

        <H6
          py={2}
          px={isModal && isMobile ? 4 : isMobile ? 2 : 0}
          sx={{
            textAlign: 'left',
            width: '100%',
          }}
        >
          {description.split('\n').map((item, key) => (
            <React.Fragment key={key}>
              {item}
              <br />
            </React.Fragment>
          ))}
        </H6>

        <Divider
          variant="middle"
          style={{ margin: '20px 0', backgroundColor: 'black', width: '100%' }}
        />

        {/* 댓글 작성 칸 */}
        <Grid
          container
          direction="row"
          justifyContent={'center'}
          alignItems={'center'}
          sx={{
            padding: isModal && isMobile ? '1rem 2rem' : '1rem 1rem',
            backgroundColor: '#ffffff',
            marginTop: '-1px',
          }}
        >
          <FlexBox
            mb={2}
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            sx={{ width: '100%' }}
          >
            <H5>댓글 6</H5>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectValue}
              placeholder="등록순"
              onChange={handleChange}
              MenuProps={{
                MenuListProps: {
                  style: {
                    padding: '0',
                    margin: '0',
                  },
                },
              }}
              input={
                <InputBase
                  sx={{
                    height: 40,
                    width: 110,
                    fontSize: 14,
                    textAlign: 'left',
                    paddingLeft: '10px !important',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    borderRadius: '8px',
                    color: 'text.primary',
                    backgroundColor: '#ffffff',
                    marginBottom: 0,
                    border: '1px solid #E1E1E1',
                    '& .MuiPopover-paper': {
                      boxShadow: 'none',
                    },
                    '& > .MuiSelect-select': {
                      paddingRight: '0 !important',
                    },
                  }}
                />
              }
            >
              <MenuItem
                sx={{
                  height: 40,
                  width: 110,
                  fontSize: 14,
                  fontWeight: 300,
                  border: '1px solid #E1E1E1',
                }}
                value={'등록순'}
              >
                등록순
              </MenuItem>
              <MenuItem
                sx={{
                  height: 40,
                  width: 110,
                  fontSize: 14,
                  fontWeight: 300,
                  border: '1px solid #E1E1E1',
                }}
                value={'제목'}
              >
                제목
              </MenuItem>
              <MenuItem
                sx={{
                  height: 40,
                  width: 110,
                  fontSize: 14,
                  fontWeight: 300,
                  border: '1px solid #E1E1E1',
                }}
                value={'내용'}
              >
                내용
              </MenuItem>
            </Select>
          </FlexBox>
          <CreateCommentBox />
        </Grid>

        {commentData.map((item, index) => {
          // const [showCommentBox, setShowCommentBox] = useState(false);

          return <Comment item={item} />;
        })}

        <Stack alignItems="center" marginY="1rem">
          {/* <ReversePagination totalItems={pageOptions.length} /> */}
          <ReversePagination totalItems={100} />
        </Stack>
      </StyledCard>
    </>
  );
}
